import React from 'react';
import PropTypes from 'prop-types';

import * as styleUtils from '../../../../utils/styleUtils';
import * as treeSelectConstants from './treeSelectConstants';

import {I18nMessage} from '../../../contexts/I18n';
import {Icon, iconConstants} from '../../Icon';

import TreeSelectItemContent from './TreeSelectItemContent';

import styles from './TreeSelect.scss';
import Checkbox from '../Checkbox';
import * as domUtils from '../../../../utils/domUtils';


function TreeSelectItems(props) {

    const {
        expandedValues,
        selectedValues,
        isFiltering,
        items,
        level,
        onExpandItem,
        onToggleItem
    } = props;

    if (items.length === 0) {

        return (
            <p className={styles.noMatches}>
                <I18nMessage id={'form.tree.select.search.noMatches'}/>
            </p>
        );
    }

    return (
        <ul className={styleUtils.toClasses(styles.items, `level-${level}`)}>

            {items.map(item => {

                const itemValue = item.value;
                const isItemExpanded = isFiltering || expandedValues.includes(itemValue);
                const isItemSelected = selectedValues.includes(itemValue);
                const isItemSelectable = item.isSelectable !== false;
                const hasItemChildren = item.children && item.children.length > 0;

                return (
                    <li
                        className={
                            styleUtils.toClasses(
                                styles.item,
                                isItemSelectable && styles.itemSelectable,
                                isItemSelected && styles.itemSelected
                            )
                        }
                        key={`tree-select-item-${itemValue}-${isItemExpanded}-${isItemSelected}`}
                    >

                        {hasItemChildren && (
                            <div
                                className={styleUtils.toClasses(styles.itemElement, styles.itemExpander)}
                                onClick={domUtils.stopEvent(() => onExpandItem(itemValue))}
                            >
                                <Icon
                                    icon={
                                        isItemExpanded
                                            ? iconConstants.ICON_MINUS_SQUARE
                                            : iconConstants.ICON_PLUS_SQUARE
                                    }
                                />
                            </div>
                        )}

                        {isItemSelectable && (
                            <div className={styleUtils.toClasses(styles.itemElement, styles.itemSelector)}>
                                <Checkbox
                                    isChecked={isItemSelected}
                                    isSmall={true}
                                    onChange={() => onToggleItem(itemValue)}
                                />
                            </div>
                        )}

                        <div
                            className={styleUtils.toClasses(styles.itemElement, styles.itemContent)}
                            onClick={domUtils.stopEvent(() => {
                                if (isItemSelectable) {
                                    onToggleItem(itemValue);
                                }
                            })}
                        >
                            <TreeSelectItemContent content={item.content}/>
                        </div>

                        {isItemExpanded && item.children?.length > 0 && (
                            <TreeSelectItems
                                {...props}
                                items={item.children}
                                level={level + 1}
                            />
                        )}

                    </li>
                );
            })}
        </ul>
    );
}


TreeSelectItems.propTypes = {
    expandedValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    isFiltering: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape(treeSelectConstants.SHAPE_TREE_SELECT_ITEM)).isRequired,
    level: PropTypes.number.isRequired,
    onExpandItem: PropTypes.func.isRequired,
    onToggleItem: PropTypes.func.isRequired
};

TreeSelectItems.defaultProps = {};


export default TreeSelectItems;
